import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import i18n from './i18n/i18n';  
// import MITO from '@zyf2e/mitojs'
// import VueHighlightJS from 'vue-highlightjs'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Element, { size: 'small', zIndex: 3000 });



Vue.prototype.$EventBus = new Vue()
// Vue.use(VueI18n) // 通过插件的形式挂载  国际化






Vue.prototype.copyObj = function(obj){
  return JSON.parse(JSON.stringify(obj));
}

/**
* 生成随机文件名
* @param len
* @returns {string}
*/
Vue.prototype.randomString = function (len) {
  len = len || 32;
  let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  let maxPos = chars.length;
  let pwd = '';
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
};
/**
 * 获取文件后缀名
 * @param filename
 * @returns {string}
 */
Vue.prototype.getSuffix = function (filename) {
  let pos = filename.lastIndexOf('.');
  let suffix = '';
  if (pos != -1) {
    suffix = filename.substring(pos)
  }
  return suffix;
};

Vue.prototype.getUrlKey = function(name){
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}


   //转换所有的zh-cn
   Vue.prototype.convertZh = function(code){
    let lowCode = code.toLowerCase()
    if(lowCode.substr(0, 2) == "zh"){
      console.log(lowCode);
      return 'zh-cn'
  }
  else{
    let lowCodeArr = lowCode.split("-")
    console.info(lowCodeArr)
    return lowCodeArr[0]
  }
  },

// Vue.use(MITO.MitoVue)
// MITO.init({
//   apikey: 'aabbcc',
//   version: '1.0.0',
//   dsn: 'http://test.com/error'
// })
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
